<template>
  <div class="container-fluid mt-0 home-page">
    
    <header class="home-overview-head">
      <div>
        <h1>市场概览</h1>
        <p>先看今日题材，再结合盘中情绪与主要指数确认市场状态</p>
      </div>
      <WxShare />
    </header>
    
    <HomeTopicHighlights />

    <header class="home-section-head">
      <div>
        <h2>市场情绪</h2>
        <span>盘中变化与中短期情绪周期</span>
      </div>
      <router-link to="/sentiment/cyclicality">详细分析 <span>→</span></router-link>
    </header>

    <div class="row chart-grid">
      <!-- Hot Trend Chart -->
      <div class="col-12 col-lg-6 mb-3">
        <div class="card shadow-sm h-100">
          <div class="card-body p-0">
            <component :is="sentimentHotTrend" v-if="showTrend" zoom_start="0" :compact="true"></component>
            <div v-else class="text-center py-5">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
              <p class="mt-2 text-muted">加载中...</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Hot Day Chart -->
      <div class="col-12 col-lg-6 mb-3">
        <div class="card shadow-sm h-100">
          <div class="card-body p-2">
            <component :is="sentimentHotDay" v-if="showDay" zoom_start="45" :compact="true"></component>
            <div v-else class="text-center py-5">
               <b-spinner variant="primary" label="Loading..."></b-spinner>
               <p class="mt-2 text-muted">加载中...</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <header class="home-section-head index-section-head">
      <div>
        <h2>主要指数</h2>
        <span>当日走势与最新涨跌幅</span>
      </div>
    </header>

    <div class="row mb-2">
      <div class="col-12">
        <SentimentIndexMiniCards />
      </div>
    </div>

    <HomeFollowedTopics />
  </div>
</template>

<script>
import WxShare from '@/components/share/WxShare.vue'
import HomeTopicHighlights from '@/components/home/HomeTopicHighlights.vue'
import HomeFollowedTopics from '@/components/home/HomeFollowedTopics.vue'
import SentimentIndexMiniCards from '@/components/sentiment/SentimentIndexMiniCards.vue'

export default {
  name: 'Home',
  components: {
    WxShare,
    HomeTopicHighlights,
    HomeFollowedTopics,
    SentimentIndexMiniCards
  },
  data() {
    return {
      sentimentHotTrend: null,
      sentimentHotDay: null,
      showTrend: false,
      showDay: false
    }
  },
  methods: {
    loadTrend() {
      import('components/sentiment/SentimentMarketHotTrend.vue').then(module => {
        this.sentimentHotTrend = module.default;
        this.showTrend = true;
      }).catch(err => {
        console.error("Failed to load trend chart:", err);
      });
    },
    loadDay() {
      import('components/sentiment/SentimentMarketHotDay.vue').then(module => {
        this.sentimentHotDay = module.default;
        this.showDay = true;
      }).catch(err => {
         console.error("Failed to load day chart:", err);
      });
    }
  },
  mounted() {
    this.loadTrend();
    this.loadDay();
  }
}
</script>

<style scoped>
.home-page { --home-ink:#263445; --home-muted:#6f7c89; --home-border:#e3e8ee; padding-top:0; }
.home-overview-head { min-height:45px; display:flex; align-items:center; justify-content:space-between; gap:16px; border-bottom:1px solid var(--home-border); }
.home-overview-head h1 { display:inline; margin:0; color:var(--home-ink); font-size:18px; font-weight:700; }
.home-overview-head p { display:inline; margin:0 0 0 10px; color:var(--home-muted); font-size:11px; }
.home-section-head { min-height:32px; display:flex; align-items:center; justify-content:space-between; gap:12px; }
.home-section-head > div { display:flex; align-items:baseline; gap:9px; }
.home-section-head h2 { margin:0; color:var(--home-ink); font-size:16px; font-weight:700; }
.home-section-head span { color:var(--home-muted); font-size:10px; }
.home-section-head > a { font-size:11px; font-weight:600; }
.index-section-head { margin-top:-2px; }
.chart-grid { margin-top:0; }
.chart-grid .card { border-color:#e3e8ee; border-radius:8px; overflow:hidden; box-shadow:0 1px 4px rgba(30,45,65,.07)!important; }
.card-body ::v-deep .echarts {
  width: 100% !important;
}
@media(max-width:650px) {
  .home-page { padding-left:8px; padding-right:8px; }
  .home-overview-head { min-height:42px; }
  .home-overview-head h1 { font-size:17px; }
  .home-overview-head p { display:none; }
  .home-section-head > div { display:block; }
  .home-section-head h2 { font-size:15px; }
}
</style>

<style>
.theme-dark .home-page { --home-ink:#e6ebf2; --home-muted:#aab4c2; --home-border:#394453; }
</style>
